import React, { isValidElement, memo } from 'react';

const SimpleCellFormatter = ({ value }: { value: any }) => {
  if (!value) {
    return <div>No Value</div>;
  } else if (typeof value === 'object' && !isValidElement(value)) {
    return <div>Invalid Value</div>;
  }

  return <div data-testid="cell-value">{value}</div>;
};

export default memo(SimpleCellFormatter, (prevProps, nextProps) => prevProps.value === nextProps.value);
